import React, {
  useCallback,
  useMemo, useState,
} from 'react'
import * as S from './styles'

interface BilletBarcodeCellProps {
  id: string
  billetsBarcode: string[]
  onAddBilletBarcode: (id: string, newBilletBarcode: string, onSuccessValidate: () => void) => void;
}

const BilletBarcodeCell = ({ id, billetsBarcode, onAddBilletBarcode }: BilletBarcodeCellProps) => {
  const [newBilletBarcode, setBilletBarcode] = useState<string>('')
  const [showInput, setShowInput] = useState<boolean>(false)

  const handleAddBilletBarcode = useCallback(() => {
    if (newBilletBarcode) {
      const onSuccessValidate = () => {
        setBilletBarcode('')
        setShowInput(false)
      }

      onAddBilletBarcode(id, newBilletBarcode, onSuccessValidate)
    }
  }, [onAddBilletBarcode, newBilletBarcode, id])

  const billetBarcodeFormatted = useCallback((billetBarcode: string) => {
    const beforeLength = 3
    const afterLength = 8
    const minLength = beforeLength + afterLength

    if (billetBarcode.length > minLength) {
      return `${billetBarcode.substring(0, beforeLength)}...${billetBarcode.substring(billetBarcode.length - afterLength, billetBarcode.length)}`
    }
    return billetBarcode
  },
  [])

  const renderInput = useMemo(() => (
    <S.Field
      tabindex={-1}
      value={newBilletBarcode}
      name='billetBarCode'
      onChange={(e) => setBilletBarcode(e.target.value)}
      autoFocus
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          setShowInput(false)
        } else if (event.key === 'Enter') {
          handleAddBilletBarcode()
        }
      }}
      autoComplete='off'
      data-testid='add-billet-barcode-input'
    />
  ), [newBilletBarcode, handleAddBilletBarcode])

  const renderButton = useMemo(() => (
    <S.Button
      type='button'
      text='supplierReceivement.form.addBilletBarCode'
      onClick={() => setShowInput(true)}
      hoverColor='none'
      data-testid='add-billet-barcode-button'
    />
  ), [])

  const renderBilletsBarcode = useMemo(() => (
    billetsBarcode.length > 0
        && billetsBarcode.map((billetBarcode) => <S.Label key={billetBarcode}>{billetBarcodeFormatted(billetBarcode)}</S.Label>)
  ), [billetsBarcode, billetBarcodeFormatted])

  return (
    <S.Container>
      {renderBilletsBarcode}
      <div>{showInput ? renderInput : renderButton}</div>
    </S.Container>
  )
}

export default React.memo(BilletBarcodeCell)
